import React from "react";
import Slider from "react-slick";
import Banner from "./Banner";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Skeleton } from "@mui/material";
import { useAppContext } from "../../context/useAppContext";
import { staticUrl } from "../../utils/baseUrl";

const SlidingBanner = ({
  bannerData,
  bannerSettings,
  onlyBanner = false,
  dots = true,
  infinite = true,
  speed = 500,
  slidesToShow = 1,
  slidesToScroll = 1,
  leftdistance,
  arrows = false,
  loading,
  reqHeight,
  isSellerPage=false
}) => {

  var settings = bannerSettings || {
    dots,
    infinite,
    speed,
    slidesToShow,
    slidesToScroll,
    arrows,
  };
  const { isDesktop } = useAppContext();

  if (loading) {
    return (
      <Skeleton
        variant="rectangular"
        width={"100%"}
        height={isDesktop ? reqHeight ?? 375 : 250}
      />
    );
  }

  if (bannerData?.length > 1) {
    return (
      <Slider {...settings}>
        {bannerData?.map((item) => (
          <div key={item?._id}>
            <Banner
              onlyBanner={onlyBanner}
              title={item?.heading}
              subtitle={item?.tagline}
              imageSrc={
                item?.contentType === "image"
                  ? `${staticUrl}/${item.name || item.image || item
                  }`
                  : item
              }
              mobile_src={item?.mobile_banner_url}
              leftdistance={leftdistance}
              textDark={true}
              buttonTitle={item?.ctaUrl ? "Get Started" : ""}
              buttonLink={item?.ctaUrl}
              contentType={item?.contentType}
              reqHeight={reqHeight}
            />
          </div>
        ))}
      </Slider>
    );
  } else {
    return (
      <Banner
        onlyBanner={onlyBanner}
        reqHeight={reqHeight}
        title={bannerData?.[0]?.heading}
        subtitle={bannerData?.[0]?.tagline}
        imageSrc={
          bannerData?.[0]?.contentType === "image"
            ? bannerData?.[0]?.url
            : bannerData?.[0]
        }
        mobile_src={bannerData?.[0]?.mobile_banner_url}
        leftdistance={leftdistance}
        textDark={true}
        buttonTitle={isSellerPage ? "" : "Get Started"}
        buttonLink={bannerData?.[0]?.ctaUrl}
        contentType={bannerData?.[0]?.contentType}
      />
    );
  }
};

export default SlidingBanner;
